export default __webpack_public_path__ + "static/media/business-model-frameworks.f69aa84e.svg";